// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed4fefe5","239":"21f264a9","667":"4dc4ce8d"}[chunkId] + ".chunk.js";
};